import { useRef, useEffect, useCallback } from "react";

const Address = ({page, formData, setFormData}) => {
  const address_InputRef = useRef();
  const mailing_InputRef = useRef();
  const addressRef = useRef();
  const mailing_addressRef = useRef();

  const parsePlace = useCallback((place, isMailingAddress) => {
    if (place) {
      let streetNumberComponent = place.address_components.find(
        (component) => component.types[0] === "street_number"
      );
      const streetNumber = streetNumberComponent !== undefined ? streetNumberComponent.short_name + ' ' : '';
      
      const streetName = place.address_components.find(
        (component) => component.types[0] === "route"
      ).short_name;
      
      let cityComponent = place.address_components.find(
        (component) => component.types[0] === "locality"
      );
      if (cityComponent === undefined) { 
        cityComponent = place.address_components.find((component) => component.types[0] === "administrative_area_level_3"); 
      }
      const city = cityComponent !== undefined ? cityComponent.short_name : '';
      
      let countyComponent = place.address_components.find(
        (component) => component.types[0] === "administrative_area_level_2"
      );
      const county = countyComponent !== undefined ? countyComponent.short_name : '';

      const state = place.address_components.find(
        (component) => component.types[0] === "administrative_area_level_1"
      ).short_name;
      
      const zip = place.address_components.find(
        (component) => component.types[0] === "postal_code"
      ).short_name;

      if (isMailingAddress) {
        setFormData((prevFormData) => ({ ...prevFormData, mailing_address_auto: document.getElementById('mailing_address_auto').value }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_address: streetNumber + streetName }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_address2: '' }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_city: city }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_county: county }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_state: state }));
        setFormData((prevFormData) => ({ ...prevFormData, mailing_zip: zip }));
      }
      else {
        setFormData((prevFormData) => ({ ...prevFormData, street_address_auto: document.getElementById('street_address_auto').value }));
        setFormData((prevFormData) => ({ ...prevFormData, street_address: streetNumber + streetName }));
        setFormData((prevFormData) => ({ ...prevFormData, street_address2: '' }));
        setFormData((prevFormData) => ({ ...prevFormData, city: city }));
        setFormData((prevFormData) => ({ ...prevFormData, county: county }));
        setFormData((prevFormData) => ({ ...prevFormData, state: state }));
        setFormData((prevFormData) => ({ ...prevFormData, zip: zip }));
      }

      console.log({ place });
    }
  }, [setFormData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleMailDifferent = (event) => {
    if (event.target.checked) {
      setFormData((prevFormData) => ({ ...prevFormData, mailing_matches: 'Yes' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address_auto: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address: formData.street_address }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address2: formData.street_address2 }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_city: formData.city }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_county: formData.county }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_state: formData.state }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_zip: formData.zip }));
      
    }
    else {
      setFormData((prevFormData) => ({ ...prevFormData, mailing_matches: 'No' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address_auto: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_address2: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_city: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_county: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_state: '' }));
      setFormData((prevFormData) => ({ ...prevFormData, mailing_zip: '' }));
      
      mailing_addressRef.current = new window.google.maps.places.Autocomplete(
        mailing_InputRef.current,
        {
          componentRestrictions: { country: "us" },
          fields: ["address_components", "name"],
          types: ["address"]
        }
      );
      mailing_addressRef.current.addListener("place_changed", async function() {
        const place = await mailing_addressRef.current.getPlace();
        parsePlace(place, true);
      });
    }
  };

  useEffect(() => {

    function loadElements() {
      addressRef.current = new window.google.maps.places.Autocomplete(
        address_InputRef.current,
        {
          componentRestrictions: { country: "us" },
          fields: ["address_components", "name"],
          types: ["address"]
        }
      );
      addressRef.current.addListener("place_changed", async function() {
        const place = await addressRef.current.getPlace();
        parsePlace(place, false);
      });
    };
    
    const handleLoad = () => { 
      loadElements();
    };

    if (page === 1 && formData.street_address === '') {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad); 
    }
  }, [page, formData.street_address, parsePlace]);

  return (
    <div>
      <div className="QuestionBox" ref={addressRef} style={{display: formData.street_address === '' ? 'flex':'none'}}>
        <label className="QuestionLabel" htmlFor='street_address_auto'>Address Lookup:</label>
        <input type='text' id='street_address_auto' name='street_address_auto' className="AddressAutocomplete QuestionInput" ref={address_InputRef} required={formData.street_address === ''} />
      </div>
      <div className="AddressFields" style={{display: formData.street_address === '' ? 'none':'flex'}}>
        <div className="AddressFieldColumns">
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='street_address'>Street Address:</label>
            <input className="AddressInput" type='text' id='street_address' name='street_address' value={formData.street_address} onChange={handleChange} required />
          </div>
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='street_address2'>Unit/Apt#:</label>
            <input className="AddressInput" type='text' id='street_address2' name='street_address2' value={formData.street_address2} onChange={handleChange} />
          </div>
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='city'>City:</label>
            <input className="AddressInput" type='text' id='city' name='city' value={formData.city} onChange={handleChange} required />
          </div>
        </div>
        <div className="AddressFieldColumns">
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='county'>County:</label>
            <input className="AddressInput" type='text' id='county' name='county' value={formData.county} onChange={handleChange} required />
          </div>
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='state'>State:</label>
            <input className="AddressInput" type='text' id='state' name='state' value={formData.state} onChange={handleChange} required />
          </div>
          <div className="AddressField">
            <label className="QuestionLabel" htmlFor='zip'>Zip:</label>
            <input className="AddressInput" type='text' id='zip' name='zip' value={formData.zip} onChange={handleChange} required />
          </div>
        </div>
      </div>
      <div className="QuestionCheckbox">
        <input type="checkbox" id="mailing_matches" name="mailing_matches" value={formData.mailing_matches} checked={formData.mailing_matches === 'Yes'} onChange={handleMailDifferent}/>
        <label htmlFor="mailing_matches">
          {formData.mailing_matches === 'Yes' ? 'This is my mailing address' : 'Remove this mailing address'}
        </label>
      </div>
      <div ref={mailing_addressRef} style={{display: formData.mailing_matches !== 'Yes' ? 'block' : 'none'}}>
        <div style={{display: formData.mailing_address === '' ? 'block' : 'none'}}>
          <label className="QuestionLabel" htmlFor='mailing_address_auto'>Mailing Address:</label>
          <input className="AddressAutocomplete QuestionInput" id='mailing_address_auto' name='mailing_address_auto' ref={mailing_InputRef} required={formData.mailing_matches !== 'Yes' && formData.mailing_address === ''} />
        </div>
        <div className="AddressFields" style={{display: formData.mailing_address === '' ? 'none' : 'flex'}}>
          <div className="AddressFieldColumns">
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_address'>Mailing Address:</label>
              <input className="AddressInput" id='mailing_address' name='mailing_address' value={formData.mailing_address} onChange={handleChange} required={formData.mailing_matches !== 'Yes'} />
            </div>
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_address2'>Unit/Apt#:</label>
              <input className="AddressInput" id='mailing_address2' name='mailing_address2' value={formData.mailing_address2} onChange={handleChange} />
            </div>
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_city'>City:</label>
              <input className="AddressInput" id='mailing_city' name='mailing_city' value={formData.mailing_city} onChange={handleChange} required={formData.mailing_matches !== 'Yes'} />
            </div>
          </div>
          <div className="AddressFieldColumns">
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_county'>County:</label>
              <input className="AddressInput" id='mailing_county' name='mailing_county' value={formData.mailing_county} onChange={handleChange} required={formData.mailing_matches !== 'Yes'} />
            </div>
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_state'>State:</label>
              <input className="AddressInput" id='mailing_state' name='mailing_state' value={formData.mailing_state} onChange={handleChange} required={formData.mailing_matches !== 'Yes'} />
            </div>
            <div className="AddressField">
              <label className="QuestionLabel" htmlFor='mailing_zip'>Zip:</label>
              <input className="AddressInput" id='mailing_zip' name='mailing_zip' value={formData.mailing_zip} onChange={handleChange} required={formData.mailing_matches !== 'Yes'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;